import React from 'react'
import {
  TruCheck,
  TruCheckCircle,
  TruCross,
  TruTick,
  TruThumbUp,
  TruThumbDown,
  TruBullet,
} from '@uswitch/spark-icons/tru'
import { toKebabCase } from './string'
import { Icon } from '../atoms'

interface ICON {
  icon: JSX.Element
  color?: string | undefined
  uswitch?: { icon: JSX.Element; color?: string | undefined }
  money?: { icon: JSX.Element; color?: string | undefined }
  confused?: { icon: JSX.Element; color?: string | undefined }
}

interface ICONS {
  [key: string]: ICON | undefined
}

const CHECKLIST_ICONS: ICONS = {
  'check-circle': { icon: <TruCheckCircle /> },
  checklist: { icon: <TruCheck /> },
  cons: { icon: <TruThumbDown /> },
  cross: { icon: <TruCross />, color: 'error' },
  pros: { icon: <TruThumbUp /> },
  'thumb-down': { icon: <TruThumbDown />, color: 'error' },
  'thumb-up': { icon: <TruThumbUp />, color: 'success' },
  tick: {
    icon: <TruTick />,
    color: 'success',
    uswitch: { icon: <Icon glyph={`tick-square`} size='32' color='#141414' /> },
  },
  'tick-circle': {
    icon: <Icon glyph={`tick-circle`} size='24' />,
    color: '#141414',
  },
  'tick-circle-white': {
    icon: <Icon glyph={`tick-circle`} size='24' />,
    color: '#ffffff',
  },
  bullet: {
    icon: <TruBullet />,
    color: 'grey-100',
    money: { icon: <TruBullet color='grey-100' size={6} /> },
  },
  numbered: undefined,
  default: { icon: <TruBullet />, color: 'grey-100' },
}

export const getIcon = (
  iconName: string,
  brand: 'uswitch' | 'money' | 'confused',
): ICON | undefined => {
  const key = toKebabCase(iconName)
  const icon = key in CHECKLIST_ICONS ? CHECKLIST_ICONS[key] : CHECKLIST_ICONS.default

  if (icon?.[brand]) {
    return icon[brand]
  }

  return icon
}

export default CHECKLIST_ICONS
